import React, { useEffect } from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import InputField from '../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import { findInMeta } from '../../../Meta/Services/meta.service';
import useWorkplaceMeta from '../../Hooks/useWorkplaceMeta';
import { MetaKey } from '../../../Meta/Enums/MetaKey.enum';
import useNotification from '../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../Hooks/useTranslation';
import useMeta from '../../../Meta/Hooks/useMeta';
// @ts-ignore
import styles from './WorkplaceProviderCode.module.scss';

const validationSchema = yup.object({
	providerCode: yup
		.string()
		.required('validation.workplaceProviderCode.providerCode'),
});

interface Props {
	workplaceId: string;
	onSuccess?: () => void;
}

const WorkplaceProviderCode: React.FC<Props> = ({ workplaceId, onSuccess }) => {
	const { workplaceMeta, reFetchWorkplaceMeta } = useWorkplaceMeta(workplaceId);
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();
	const { createWorkplaceMeta } = useMeta();

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	useEffect(() => {
		const providerCode = findInMeta({
			meta: workplaceMeta,
			metaKey: MetaKey.PROVIDER_CODE,
		})?.value;
		if (providerCode) {
			formMethods.reset({
				providerCode,
			});
		}
	}, [workplaceMeta]);

	const handleSubmit = async (values: any) => {
		const result = await createWorkplaceMeta({
			workplaceId,
			meta: {
				key: MetaKey.PROVIDER_CODE,
				value: values.providerCode,
			},
		});
		if (result.status === 200) {
			showNotificationSuccess({
				content: t('base.saved'),
			});
			reFetchWorkplaceMeta();
			onSuccess?.();
		}
	};

	return (
		<div className={styles.wrapper}>
			<div className='row'>
				<div className='col-md-6 col-12'>
					<FormWrapper formMethods={formMethods}>
						<InputField
							label='component.workplaceProviderCode.providerCode'
							name='providerCode'
							isWrapped
							isRequired
						/>
						<SubmitButton onSubmit={handleSubmit} title='base.shared.save' />
					</FormWrapper>
				</div>
			</div>
		</div>
	);
};

export default WorkplaceProviderCode;
